import React from 'react';
import isElectron from 'is-electron';
import appConfig from 'app-config';
import {
    getQueryParam,
    setAdminLocationToStorage,
} from 'flow/utils/browser-utils';

interface WithLocationProps {
    location: {
        search: string;
        [key: string]: any;
    };
}

const saveAdminLocationToStorage = (apiHost?: string) => {
    if (apiHost) {
        setAdminLocationToStorage(apiHost);
    }
};

/**
 * This is a Higher Order Component that wraps other components.
 * Its function is to remember which domain the admin pages are located at for
 * this webapp, whether it's home.telavox.se or some cloud partners own domain,
 * like hem.tele10.se.
 *
 * @param WrappedComponent
 */
export function setAdminLocation<T extends WithLocationProps>(
    WrappedComponent: React.ComponentType<T>,
) {
    return class Wrapper extends React.Component<T> {
        constructor(props: T) {
            super(props);
            const { location } = this.props;

            if (!isElectron() && appConfig.production) {
                const hostParam = getQueryParam(location.search, 'host');
                if (hostParam) {
                    saveAdminLocationToStorage(hostParam);
                }
            }
        }

        render() {
            return <WrappedComponent {...this.props} />;
        }
    };
}
